/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import util from 'meinian-package/src/utils/util'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import ImageDetail from 'view/detail/imageDetail'
import { ossImg } from 'meinian-package/src/utils/image'
import { getViewConfig, CONFIG_KEY } from 'view/detail/imageDetail/infoView/info/originalText/config'
import { hasFromData } from 'view/detail/imageDetail/infoView/info/originalText'
import { Layer } from '../image.base'
import { BatchItem } from '../../../batch'
import { TITLE_CONFIG, TITLE_INS_CONFIG, isFun } from './config'
import { StyleStateLabel } from '../styleInfo'

const Image = (props) => {
  const {
    platformId,
    outerIndex,
    total,
    data = [],
    mainUrl,
    imageGroupEntityId,
    inspirationId,
    isBatch,
    // defaultTab,
    onClickCard,
    columnWidth,
    maxHeight = 500,
    // trackSourceType,
    viewConfig = {}, // 视图设置
    item: itemData
  } = props

  const { config, dtoConfig } = getViewConfig(itemData.platformId, itemData.isFromZkPlatform)
  const dto = itemData?.[dtoConfig?.dto]
  const [visible, setVisible] = useState(false)
  const [index, setIndex] = useState(outerIndex)

  useEffect(() => {
    setIndex(outerIndex)
  }, [outerIndex])

  const onChangeIndex = (_outerIndex) => {
    setIndex(_outerIndex)
    props.onChangeIndex && props.onChangeIndex(_outerIndex)
  }

  const _onChange = (success, itemParams) => {
    if (success) {
      props.setData((pre) => {
        const i = pre.findIndex(item => item.inspirationId === itemParams.inspirationId
          && item.imageGroupEntityId === (itemParams.imageGroupEntityId || itemParams.entityId))
        if (i !== -1) {
          pre[i] = { ...pre[i], ...itemParams }
        }
        return [...pre]
      })
      props.onResize()
    }
  }
  const auth = itemData.loginUserInfo?.inspirationPermissions || []
  const cardHeight = viewConfig.imageType === 'proportionally' ? columnWidth : Math.round((columnWidth * props.height) / props.width)

  const titleConfig = TITLE_CONFIG[platformId]

  if (!config) {
    return
  }
  const infoBlock = config[CONFIG_KEY.CARD_INFO_BLOCK] ? config[CONFIG_KEY.CARD_INFO_BLOCK] : config[CONFIG_KEY.INFO_BLOCK] || []

  return <div style={{ width: columnWidth, height: cardHeight, maxHeight }}>
    {
      isBatch ? <div className={classNames('meinian-waterfall-card-image')}>
        <img loading="lazy" src={ossImg(mainUrl, 400)} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '9px' }} />
        <div className="batch-mask">
          <BatchItem keyValue={`${imageGroupEntityId},${inspirationId}`} className="batch-check" info={data[outerIndex]} />
        </div>
      </div> : <div
        className={classNames('meinian-waterfall-card-image')}
        onClick={e => {
          if (window.location.pathname.startsWith('/meinian/home/workbench')) {
            util.track('mn-workbench-click', {
              module1: '款式查看',
              module2: props.trackModule2,
              module3: '款式详情',
            })
          }
          onClickCard ? onClickCard(data[outerIndex], e) : setVisible(true)
        }}
      >
        <img loading="lazy" src={ossImg(mainUrl, 400)} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '9px' }} />
        <Layer
          {...props}
          onChange={_onChange}
          itemData={itemData}
          hiddenMark={viewConfig.markInfo && columnWidth >= 270}
        >
          {
              titleConfig
              && dto && viewConfig.originalInfo
               && platformId !== PLATFORM_VALUE.INS
               && platformId !== PLATFORM_VALUE.CROSSBORDER_INS && <>
                 {
                  !!infoBlock.length && <div className="card-num">
                    {infoBlock.map(blockInfo => <span><span className="num">{
                      // eslint-disable-next-line react/jsx-no-useless-fragment
                      Array.isArray(blockInfo.valueKey) ? <>
                        { `${hasFromData(blockInfo, dto[blockInfo.valueKey[0]])}/${hasFromData(blockInfo, dto[blockInfo.valueKey[1]])}`}
                      </> : <>
                        {hasFromData(blockInfo, dto[blockInfo.valueKey])}
                      </>
                    }</span><span className="name">{blockInfo.label}</span></span>)}
                  </div>
                }
                 <div onClick={(e) => {
                   e.stopPropagation()
                   titleConfig.linkUrl && window.open(titleConfig.linkUrl(dto, itemData))
                 }}
                 >
                   <Title title={isFun(titleConfig.title) ? titleConfig.title(dto) : dto[titleConfig.title]} />
                 </div>
               </>
}
          {titleConfig
            && dto
            && viewConfig.originalInfo
            && (platformId === PLATFORM_VALUE.INS || platformId === PLATFORM_VALUE.CROSSBORDER_INS) && <Ins
              dto={dto}
              infoBlock={infoBlock}
              itemData={itemData}
            />}
        </Layer>
        <StyleStateLabel auth={auth} itemData={itemData} viewConfig={viewConfig} />
      </div>
    }
    {visible ? <ImageDetail
      outerIndex={index}
      listLength={total || data.length}
      onChangeIndex={onChangeIndex}
      visible={visible}
      blogId={data?.[index].imageGroupEntityId}
      inspirationId={data?.[index].inspirationId}
      collectId={data?.[index].collectId}
      onChange={_onChange}
      onVisibleChange={(_visible) => { setVisible(_visible); setIndex(outerIndex) }}
      onDeleteItem={props.onDeleteItem}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}
export default Image

const Ins = ({ dto, infoBlock, itemData }) => {
  const titleConfig = !dto.includedFlag || !dto.bloggerObj ? TITLE_INS_CONFIG[0] : TITLE_INS_CONFIG[1]
  return <>
    {
      !!infoBlock.length && <div className="card-num">
        {infoBlock.map(blockInfo => <span><span className="num">{hasFromData(blockInfo, dto[blockInfo.valueKey])}</span><span className="name">{blockInfo.label}</span></span>)}
      </div>
    }
    <div onClick={(e) => {
      e.stopPropagation()
      titleConfig.linkUrl && window.open(titleConfig.linkUrl(dto, itemData))
    }}
    >
      <Title title={isFun(titleConfig.title) ? titleConfig.title(dto) : dto[titleConfig.title]} />
    </div>
  </>
}

const Title = ({ title, style }) => <span className="title" style={style}>{title}</span>
